import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthService } from '../../auth/auth.service';
import { LoadingService } from '@shared/loading';
import { ToastService } from '@shared/events/toast.service';

@Injectable()
export class OrganizacionService {
  private _orgs = new BehaviorSubject<any[]>([]);
  public orgs$ = this._orgs.asObservable();

  constructor(
    private http: HttpClient,
    private auth: AuthService,
    private router: Router,
    private loading: LoadingService,
    private toast: ToastService
  ) {}

  public obtenerOrganizacionActiva() {
    return localStorage.getItem('CodOrganizacion');
  }

  public obtenerListaOrganizaciones() {
    return this.http
      .get<any[]>(`${environment.API_URL}/ListOrganizacion`)
      .pipe(tap((orgs) => this._orgs.next(orgs)));
  }

  public async actualizarOrganizacion(
    CodOrganizacion: string,
    Redirigir?: boolean
  ) {
    await firstValueFrom(
      this.auth.refrescarToken(
        CodOrganizacion.toString(),
        CodOrganizacion.toString(),
        null,
        1
      )
    );

    this.loading.isLoading = true;

    this.auth
      .refrescarToken(
        CodOrganizacion.toString(),
        CodOrganizacion.toString(),
        null,
        1
      )
      .subscribe(() => {
        this.loading.isLoading = false;
        localStorage.setItem('CodOrganizacion', CodOrganizacion);
        if (Redirigir) {
          this.router.navigate(['/dashboard']);
        } else {
          window.location.reload();
        }
      },
      (error) => {
        this.toast.toastError(error?.error?.Message ?? 'Se ha producido un error');
        this.loading.isLoading = false;
      });
  }

  public async actualizarMultiFactoApp(PSK: string) {
    await firstValueFrom(this.auth.refrescarToken(null, null, PSK.toString(), 2));
    this.auth.refrescarToken(null, null, PSK.toString(), 2).subscribe();
  }
}
